import axios from "axios"
import { logout } from "features/User/redux/slices/userSlice"
import i18next from "i18next"
import qs from "qs"
import notification from "../../common/utils/notification"

const extractDescription = (error: $TSMigrationFixMe) => {
  return typeof error === "string" ? error : error?.description
}

const showHandledError = (error: $TSMigrationFixMe) => {
  const errorDescription = extractDescription(
    error?.response?.data?.errors?.[0]
  )
  const errorDescriptionsToIgnore = [
    /el usuario ya existe/i,
    "Invalid certificate!",
  ]
  if (
    errorDescriptionsToIgnore.some((description) =>
      errorDescription?.match(description)
    )
  ) {
    return
  }
  notification.errorServidor({
    body: errorDescription,
  })
}

const handledErrors = {
  InvalidCredentials: () =>
    notification.errorServidor({
      body: `${i18next.t("notification.emainOrPasswordIncorrect")}`,
    }),
  DuplicateUserName: () =>
    notification.errorServidor({
      body: `${i18next.t("notification.emailAlreadyRegistered")}`,
    }),
}

const getErrorKey = (error: $TSMigrationFixMe) => {
  return error?.response?.data?.errors?.[0]?.code || error?.response?.data?.code
}

export default {
  setupInterceptors: (store: $TSMigrationFixMe) => {
    axios.interceptors.request.use(
      (config) => {
        const token = sessionStorage.getItem("access_token")

        const newConfig = { ...config }
        if (!newConfig?.baseURL) {
          newConfig.baseURL = import.meta.env.REACT_APP_API_URL
        }
        if (!newConfig.responseType) newConfig.responseType = "json"

        newConfig.paramsSerializer = (params) =>
          qs.stringify(params, {
            arrayFormat: "repeat",
          })

        newConfig.headers.Authorization = `Bearer ${token}`

        return newConfig
      },
      (error) => Promise.reject(error)
    )
    axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === 401) {
          store.dispatch(logout())
        }

        if (`${error.response?.status}`?.match(/(400|406|424|415)/g)) {
          const errorKey = getErrorKey(error)
          // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre...
          if (handledErrors[errorKey]) {
            // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre...
            handledErrors[errorKey](error)
          } else {
            showHandledError(error)
          }
        }

        return Promise.reject(error)
      }
    )
  },
}
